// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `mat-slide-toggle {
  margin: 0;
}
.modal-body .form-row {
  margin: 8px 0;
}
.modal-header {
  background-color: #0f1a35;
  color: white !important;
}
.modal-header .modal-title {
  font-size: 20px !important;
  font-weight: 600;
}
.modal-header .close {
  color: red;
  text-shadow: none;
  opacity: 1;
  font-size: 26px;
  padding: 0 !important;
  margin: 0 !important;
  box-shadow: none;
  background: transparent;
  right: 20px;
  position: absolute;
}
.modal-footer {
  padding: 2px !important;
}
.bigAssModal .modal-dialog {
  max-width: 90% !important;
}
.nav-item {
  overflow: hidden;
  outline: 0;
  cursor: pointer;
  position: relative;
  box-sizing: content-box;
  display: flex;
  height: 52px;
  align-items: center;
  color: rgba(0, 0, 0, 0.54);
  font-family: Roboto, "Helvetica Neue", sans-serif;
}
.le-label {
  padding-top: 0 !important;
}
.snappt-label {
  color: red;
  font-weight: bold;
}
`, "",{"version":3,"sources":["webpack://./src/assets/ngb-modals.less","webpack://./src/app/shared-components-module/income-source-modal/income-source-modal.component.less"],"names":[],"mappings":"AAEA;EACE,SAAA;ACDF;ADGA;EACI,aAAA;ACDJ;ADIA;EACI,yBAAA;EACA,uBAAA;ACFJ;ADAA;EAKO,0BAAA;EACA,gBAAA;ACFP;ADJA;EASO,UAAA;EACC,iBAAA;EACA,UAAA;EACD,eAAA;EACA,qBAAA;EACA,oBAAA;EACA,gBAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;ACFP;ADMA;EACI,uBAAA;ACJJ;ADOA;EACI,yBAAA;ACLJ;AA9BA;EACI,gBAAA;EACA,UAAA;EACA,eAAA;EACA,kBAAA;EACA,uBAAA;EACA,aAAA;EACA,YAAA;EACA,mBAAA;EAEA,0BAAA;EACA,iDAAA;AA+BJ;AA3BE;EACE,yBAAA;AA6BJ;AA1BA;EACE,UAAA;EACA,iBAAA;AA4BF","sourcesContent":["@import (reference) url('../styles.less');\n\nmat-slide-toggle {\n  margin: 0;\n}\n.modal-body .form-row{\n    margin: 8px 0;\n}\n\n.modal-header{\n    background-color: #0f1a35;\n    color: white !important;\n    \n    .modal-title{\n       font-size: 20px !important;\n       font-weight: 600;\n    };\n    .close{\n       color: red;\n        text-shadow: none;\n        opacity: 1;\n       font-size: 26px;\n       padding: 0 !important;\n       margin : 0 !important;\n       box-shadow: none;\n       background: transparent;\n       right: 20px;\n       position: absolute;\n    }\n}\n\n.modal-footer{\n    padding: 2px !important;\n}\n\n.bigAssModal .modal-dialog{\n    max-width: 90% !important;\n}","@import '../../../assets/ngb-modals.less';\n.nav-item{\n    overflow: hidden;\n    outline: 0;\n    cursor: pointer;\n    position: relative;\n    box-sizing: content-box;\n    display: flex;\n    height: 52px;\n    align-items: center;\n    // padding: 0 25px;\n    color: rgba(0,0,0,.54);\n    font-family: Roboto,\"Helvetica Neue\",sans-serif;\n    // margin: 0 3%\n  }\n\n  .le-label{\n    padding-top: 0 !important;\n}\n\n.snappt-label{\n  color: red;\n  font-weight: bold;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
